import { Link } from 'react-router-dom';
import { SITE } from '~/content/site.js';

export function Footer() {
  return (
    <footer className="mt-24 border-t border-line">
      <div className="mx-auto flex max-w-(--container-content) flex-col gap-6 px-5 py-10 sm:px-8 md:flex-row md:items-start md:justify-between">
        <div className="max-w-md">
          <p className="font-heading text-base font-semibold tracking-[-0.03em] text-heading">
            {SITE.companyName}
            <span className="text-primary">.</span>
            <span className="ml-2 text-sm font-normal text-muted">/ {SITE.careersName}</span>
          </p>
          <p className="mt-2 text-sm text-muted">{SITE.location}</p>
        </div>

        <nav aria-label="Footer" className="flex flex-col gap-2 text-sm sm:flex-row sm:gap-8">
          <Link to="/#open-roles" className="text-body hover:text-primary">
            Open positions
          </Link>
          <Link to="/privacy" className="text-body hover:text-primary">
            Applicant privacy
          </Link>
          <a href={SITE.mainSiteUrl} className="text-body hover:text-primary" rel="noopener noreferrer">
            Studio website
          </a>
        </nav>
      </div>

      <div className="border-t border-line">
        <p className="mx-auto max-w-(--container-content) px-5 py-5 text-xs text-muted sm:px-8">
          © {new Date().getFullYear()} {SITE.legalName}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
